/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_FailedInputs */

const en_us2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your conversations.`)
};

const pt_br2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar as conversas.`)
};

const es_419_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar tus conversaciones.`)
};

const pt_pt2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as conversas.`)
};

const fr_fr2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger tes conversations.`)
};

const de_de2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Unterhaltungen konnten nicht geladen werden.`)
};

const it_it2_coach_extra_conversations_failed = /** @type {(inputs: Coach_Extra_Conversations_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le conversazioni.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your conversations." |
*
* @param {Coach_Extra_Conversations_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_failed = /** @type {((inputs?: Coach_Extra_Conversations_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_failed(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_failed(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_failed(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_failed(inputs)
	return en_us2_coach_extra_conversations_failed(inputs)
});
export { coach_extra_conversations_failed as "coach-extra.conversations_failed" }